// extracted by mini-css-extract-plugin
module.exports = {"lrvIcon":"Icon_lrvIcon__xgTmJ","iconDark":"Icon_iconDark__1fSB9","iconLight":"Icon_iconLight__2Q5Cx"};